module.exports = __webpack_public_path__ + "img/complete.2f4f5d97.png";